export interface LegalLink {
  readonly slug: string;
  readonly label: string;
}

/// Alt bilgi sırası (docs/legal/drafts/00-README.md önerisi). Metinler
/// src/content/legal/<slug>.md'den derlenir (Task 11).
export const LEGAL_LINKS: readonly LegalLink[] = [
  { slug: 'hizmet-kosullari', label: 'Hizmet ve Abonelik Koşulları' },
  { slug: 'mesafeli-satis-sozlesmesi', label: 'Mesafeli Satış Sözleşmesi' },
  { slug: 'on-bilgilendirme', label: 'Ön Bilgilendirme Formu' },
  { slug: 'iptal-iade', label: 'İptal, İade ve Cayma' },
  { slug: 'kvkk', label: 'KVKK Aydınlatma Metni' },
  { slug: 'gizlilik', label: 'Gizlilik Politikası' },
  { slug: 'cerez-politikasi', label: 'Çerez Politikası' },
];

export const LEGAL_SLUGS: readonly string[] = LEGAL_LINKS.map((l) => l.slug);
